import React, { useState, useRef } from "react";
import { StyleSheet, Text, View, StatusBar } from "react-native";
import Route from "./src/route/route";
import {
  RecoilRoot,
  atom,
  selector,
  useRecoilState,
  useRecoilValue,
} from "recoil";
import { useFonts } from "expo-font";

const App = () => {
  const [loaded] = useFonts({
    "Prompt-Regular": require("./assets/fonts/Prompt-Regular.ttf"),
    "Prompt-Bold": require("./assets/fonts/Prompt-Bold.ttf"),
  });

  if (!loaded) {
    return null;
  }

  return (
    <RecoilRoot>
      <StatusBar barStyle={"dark-content"} />
      <View style={styles.container}>
        <Route />
      </View>
    </RecoilRoot>
  );
};
export default App;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
});
